/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Calendar, Badge, Skeleton, Empty, Popconfirm, message } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import '../index.scss'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import AddForm from './addForm'
import ViewDetails from './view'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isAddFormShown: false,
			isViewEventShown: false,
			selectedDate: null,
			selectedEvent: null,
			isReloadCalender: false
		}
        
		this.dateCellRender = this.dateCellRender.bind(this)
		this.monthCellRender = this.monthCellRender.bind(this)
		this.onCellDateSelect = this.onCellDateSelect.bind(this)
		this.disabledDate = this.disabledDate.bind(this)
	}
    
	disabledDate (value) {
		return value < moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')
		// return value < moment(new Date(), 'YYYY-MM-DD')
	}
    
	dateCellRender(value) {
		// console.log('value dateCellRender', value)
		const { AuthStore } = this.props
		const { barangay_uid } = AuthStore
		return (
			<Query 
				query={EVENT_BY_DATE} 
				variables={{ barangay_uid, event_date: moment(value).format('YYYY-MM-DD') }}
				fetchPolicy='network-only'
			>
				{({ loading, error, data }) => {
					if (loading) return <Skeleton active/>
					if (error) return <Empty/>

					let mEvents = _.has(data,'eventByDate') ? data.eventByDate : []
					//console.log('mEvents', mEvents)
					if (mEvents && (mEvents.length > 0)) {
						return (
							<React.Fragment>
								{
									(value > moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')) &&
									<Row>
										<a 
											href='javascript:void(0)'
											style={{ fontSize: 11 }}
											onClick={() => this.onCellDateSelect(value)}
										><i className='fe-plus'></i> New Event</a>
									</Row>
								}
								<Row>
									<ul className="events">
										{mEvents.map(item => (
											<Popconfirm
												key={item.uid}
												title="View / Edit"
												onConfirm={() => {
													this.setState({ isViewEventShown: true, selectedEvent: item })
												}}
												onCancel={() => {
													if (value > moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')) {
														this.setState({ isAddFormShown: true, selectedEvent: item })
													} else {
														message.error('You cannot edit past date event.')
													}
												}}
												okText="View"
												cancelText="Edit"
											>
												<li>
													<Badge status='warning' text={item.name} />
												</li>
											</Popconfirm>
										))}
									</ul>
								</Row>
							</React.Fragment>
						)
					} else {
						if (value > moment(new Date(), 'YYYY-MM-DD').subtract(1, 'day')) {
							return (
								<a 
									href='javascript:void(0)'
									style={{ fontSize: 11 }}
									onClick={() => this.onCellDateSelect(value)}
								><i className='fe-plus'></i> New Event</a>
							)
						}
						return null
					}
				}}
			</Query>
		)
	}
    
	monthCellRender(value) {
		console.log('value monthCellRender', moment(value).format('YYYY-MM'))
	}
    
	onCellDateSelect(value) {
		// console.log('value onCellDateSelect', value)
		this.setState({ isAddFormShown: true, selectedDate: moment(value).format('YYYY-MM-DD') })
	}

	render() {
		const { isReloadCalender, isAddFormShown, isViewEventShown, selectedDate, selectedEvent } = this.state
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Barangay Management</a></li>
									<li className="breadcrumb-item active">Events</li>
								</ol>
							</div>
							<h4 className="page-title">Events</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								{
									!isReloadCalender &&
                                    <Calendar 
                                    	disabledDate={this.disabledDate}
                                    	dateCellRender={this.dateCellRender} 
                                    	monthCellRender={this.monthCellRender}
                                    	// onSelect={this.onCellDateSelect}
                                    />
								}
							</div>
						</div>
					</div>
				</div>
				{
					isAddFormShown &&
                    <AddForm
                    	selectedEvent={selectedEvent}
                    	selectedDate={selectedDate}
                    	visible={isAddFormShown}
                    	onClose={() => this.setState({ isAddFormShown: false, selectedEvent: null, isReloadCalender: true }, () => {
                    		this.setState({ isReloadCalender: false })
                    	})}
                    />
				}
				{
					isViewEventShown &&
					<ViewDetails 
						event_uid={selectedEvent.uid}
						visible={isViewEventShown}
						onCancel={() => this.setState({ isViewEventShown: false, selectedEvent: null, isReloadCalender: true }, () => {
							this.setState({ isReloadCalender: false })
						})}
					/>
				}
			</React.Fragment>
		)
	}
}

const EVENT_BY_DATE = gql`
    query eventByDate($barangay_uid: String, $event_date: String) {
		eventByDate(barangay_uid: $barangay_uid, event_date: $event_date)
    }
`

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
